<fui-multiselect-control
    [options]="options"
    [(value)]="selectedValue"
    (valueChange)="updateStateOnValueChange()"
    [disabled]="false"
    [labelField]="'label'"
    [label]="'fhm.control.venue-require-action-multi-select.label'"
    [loading]="false"
    [placeholder]="' '"
    [valueField]="'value'"
    [internallyFilterable]="true"
    (removed$)="removed.emit()"
    [showExtendedSearchOption]="false"
    [showAddOption]="false">
</fui-multiselect-control>
